export default "__VITE_ASSET__AvOD0oRi__"